import { AvatarConsts } from '@treneo/shared/constants';

import MuiAvatar from '@mui/material/Avatar';

import { styled } from '../../styled';

import { AvatarUtils } from './avatar.utils';

type Props = {
  displayName: string;
  color: string;
  size?: string;
  shouldBiggerOnHover?: boolean;
};

const StyledMuiAvatar = styled(MuiAvatar)`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Avatar = ({
  displayName,
  color,
  size = AvatarConsts.defaultAvatarSize,
  shouldBiggerOnHover = false
}: Readonly<Props>) => {
  const initial = AvatarUtils.getAvatarInitials(displayName);

  return (
    <StyledMuiAvatar
      sx={[
        { backgroundColor: color, height: size, width: size },
        shouldBiggerOnHover
          ? () => ({
              '&:hover': {
                transform: 'scale(1.3)',
                transition: 'transform .5s'
              }
            })
          : {}
      ]}
    >
      <div>{initial}</div>
    </StyledMuiAvatar>
  );
};
